import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import MarkdownEditor from '../../components/Markdown/MarkdownEditor';

// Shared rich-text editor. Now backed by the Markdown editor: authors write Markdown
// (stored as-is) so rich-text content clears the upstream WAF, which flags embedded
// HTML tags/links as attacks. Same props as before, so existing consumers (FAQs,
// Branches, Notices, ...) work unchanged. Edit forms should convert any legacy HTML
// value to Markdown (htmlToMarkdown) when they seed their initial value.
const TextEditor = ({ value, onChange, error, touched, height = '300px' }) => {
    const numericHeight = typeof height === 'string' ? (parseInt(height, 10) || 300) : height;

    return (
        <Box>
            <MarkdownEditor value={value} onChange={onChange} height={numericHeight} />
            {touched && error && (
                <Text color="red.500" fontSize="sm" mt="8px">{error}</Text>
            )}
        </Box>
    );
};

export default TextEditor;
